import type { ProfessionalTypeEnum } from '@gql/graphql';
import type { LocationDescriptor } from 'history';
import type { MouseEventHandler } from 'react';

export interface JoinProInfoPageHeaderData {
  title: string;
  subtitle: string;
}

export interface JoinProInfoPageSectionData {
  title: string;
  subtitle?: string;
  texts: string[];
  image: string;
}

export interface JoinProInfoPageMoreCardData {
  title: string;
  image: string;
  link: LocationDescriptor;
}

export interface JoinProInfoPageFaqData {
  title: string;
  text: string;
}

export enum JoinProInfoPageType {
  SEO = 'SEO',
  PROFILE = 'PROFILE',
  BOOKING = 'BOOKING',
  AGENDA = 'AGENDA',
}

export interface JoinProInfoPageData {
  type: JoinProInfoPageType;
  proType: ProfessionalTypeEnum;
  onButtonClick?: MouseEventHandler;
  header: JoinProInfoPageHeaderData;
  sections: JoinProInfoPageSectionData[];
  moreCards: JoinProInfoPageMoreCardData[];
  faqItems?: JoinProInfoPageFaqData[];
}

export interface JoinProInfoPageProps extends JoinProInfoPageData {}
